let audio: HTMLAudioElement | null = null
let lastPlayAt = 0
let resumePending = false

const THROTTLE_MS = 2000

function ensureAudio(): HTMLAudioElement {
  if (!audio) {
    audio = new Audio('/alarm.mp3')
    audio.loop = false
    audio.preload = 'auto'
    audio.volume = 0.8
  }
  return audio
}

function registerOneTimeResume(aud: HTMLAudioElement) {
  if (resumePending) return
  resumePending = true

  const resume = () => {
    aud.play().catch(() => {})
    window.removeEventListener('pointerdown', resume)
    window.removeEventListener('keydown', resume)
    resumePending = false
  }

  window.addEventListener('pointerdown', resume, { once: true })
  window.addEventListener('keydown', resume, { once: true })
}

export async function playNotificationSound(): Promise<void> {
  const now = Date.now()
  if (now - lastPlayAt < THROTTLE_MS) {
    // Throttle to avoid loops or rapid repeats
    return
  }
  lastPlayAt = now

  const aud = ensureAudio()

  try {
    // Restart from start to ensure a crisp single beep
    try {
      aud.currentTime = 0
    } catch {}
    await aud.play()
  } catch {
    // Autoplay blocked, register a single resume handler
    registerOneTimeResume(aud)
  }
}
